<template>
    <div class="conflict-dialog">
        <Button
            class="p-button"
            label="Overwrite (retain history)"
            severity="danger"
            @click="
                () => {
                    emit('overwrite');
                    dialogRef!.close();
                }
            "
        />
        <Button
            class="p-button"
            :label="`Save as &quot;${dialogRef?.data.uniqueName}&quot;`"
            severity="primary"
            @click="
                () => {
                    emit('saveAsUnique');
                    dialogRef!.close();
                }
            "
        />
        <Button
            class="p-button"
            label="Cancel"
            severity="secondary"
            @click="
                () => {
                    emit('cancel');
                    dialogRef!.close();
                }
            "
        />
    </div>
</template>
<script lang="ts" setup>
import { Ref, inject } from "vue";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";

const dialogRef = inject<Ref<DynamicDialogInstance> | undefined>("dialogRef");

const emit = defineEmits(["overwrite", "saveAsUnique", "cancel"]);
</script>

<style scoped lang="scss">
.conflict-dialog {
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 1em;
    width: fit-content;
    margin: auto;
}
</style>
